import { Text } from "../../../../components/general/Text";
import { useEffect, useMemo } from "react";
import { getTokenIcon } from "../../../../utils/tokenIconUtils";
import { useTokenListByChain } from "../../../../hooks/useTokenListByChain";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import styled from "@emotion/styled";
import GreenTickIcon from "../../../../img/approval_svgs/approved.svg?react";
import { OrderStatus } from "../../../../types/orderStatus";
import { WrapQuoteStatus } from "../../../../types/wrapQuote";
import { isNativeToken } from "../../../../utils/wrapUtils";
import { motion } from "framer-motion";
import { getNameForToken, getSymbolForToken } from "../../../../utils/tokenListUtils";
import { getWrappedTokenAddress } from "../../../../utils/chainUtils";

export const WrappingQuoteCompleted = () => {
  const tokenList = useTokenListByChain();
  const { network, theme } = GlobalStore.useState(s => ({
    network: s.network,
    theme: s.theme,
  }));
  const wrappedIcon = useMemo(
    () => getTokenIcon(getWrappedTokenAddress(network), tokenList),
    [network, tokenList]
  );

  useEffect(() => {
    setTimeout(() => {
      GlobalStore.update(s => {
        s.orderStatus = OrderStatus.ENTRY;
        s.takerTokens.map(el =>
          isNativeToken(el.tokenAddress, network)
            ? (el.tokenAddress = getWrappedTokenAddress(network))
            : ""
        );
        s.wrapQuoteStatus = WrapQuoteStatus.PENDING_WALLET_CONFIRM;
      });
    }, 2000);
  });

  return (
    <Container initial={"initial"} variants={slideVariants} animate={"slide"}>
      <IconWrapper>
        <img src={wrappedIcon} alt={"Wrapped token icon"} width={102} height={102} />
        <StyledGreenTick />
      </IconWrapper>
      <DescriptionWrapper>
        <Text textStyle="Title" size="Medium" color={theme.font.primary.default}>
          You are now ready to trade with{" "}
          {getNameForToken(getWrappedTokenAddress(network), tokenList)}
        </Text>
        <Text textStyle={"Paragraph"} size={"Large"} color={theme.font.secondary.default}>
          Your {network.nativeCurrency.symbol} was successfully converted to{" "}
          {getSymbolForToken(getWrappedTokenAddress(network), tokenList)}.
        </Text>
      </DescriptionWrapper>
    </Container>
  );
};

const slideVariants = {
  initial: { x: 20 },
  slide: { x: 0 },
};

const Container = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 16px;
`;

const IconWrapper = styled.div`
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledGreenTick = styled(GreenTickIcon)`
  position: absolute;
  width: 32px;
  height: 32px;
  right: 0;
  bottom: 15%;
`;

const DescriptionWrapper = styled.div`
  display: flex;
  padding: 14px 28px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;
